import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { Body, Heading } from '../../typography';
import { getBaseUrl } from '../../../lib/utils';
import { instanceBase as axios } from '../../../lib/axios';
import { IDP_ENDPOINT } from '../../../config';

const Box = styled.div`
    border-radius: calc(var(--space-unit) / 2);
    border: var(--border-size-small) solid var(--gray300);
    background-color: var(--gray50);
    padding: calc(var(--space-unit) * 2);
    max-width: 400px;
`;

const Paragraph = styled.p`
    color: var(--gray800);
    width: 397px;
    margin: var(--space-unit);
`;

const ChangeUser = styled.button`
    color: var(--blue500);
    text-decoration: none;
    border: none;
    background-color: var(--gray50);

    &:hover {
        text-decoration: underline;
        cursor: pointer;
    }
`;

const WrongVirtualClass = ({ application, auth }) => {
    return (
        <>
            <Heading level={2} weight="light">
                {'Questa prova è riservata'}
            </Heading>
            <br />
            <Body>{`Questa prova è stata assegnata alla classe ${application?.className}, ed è riservata.`}</Body>
            <Body>{`Fai parte della ${application?.className}? Controlla se l'account che stai usando è quello giusto.`}</Body>
            <br />
            <Box>
                <Paragraph>
                    {"Stai usando l'account "}
                    <b>{`${auth?.firstName} ${auth?.lastName}`}</b>
                    {' ('}
                    {auth?.email}
                    {').'}
                </Paragraph>
                <Paragraph className="body-5">
                    {"Non è l'account giusto?"}{' '}
                    <ChangeUser
                        onClick={async () => {
                            let redirectTo = getBaseUrl();
                            await axios.get(`${IDP_ENDPOINT}/v1/logout`);
                            window.location.replace(`${redirectTo}?id=${application?.uniqueCode}`);
                        }}
                    >
                        {'Usa un altro account'}
                    </ChangeUser>
                </Paragraph>
            </Box>
            <br />
            <Body>{`Hai bisogno di aiuto? Contattaci`}</Body>
            <br />
        </>
    );
};

WrongVirtualClass.propTypes = {
    application: PropTypes.object,
    auth: PropTypes.object,
};

function mapStateToProps(state) {
    return {
        application: state.application,
        auth: state.auth,
    };
}

export default connect(mapStateToProps)(WrongVirtualClass);
